const localeMapping = {
  ja_JP: 'ja-jp',
  en_US: 'en-us',
};
export default localeMapping;
